import { render, staticRenderFns } from "./ScreenObjectQuickView.vue?vue&type=template&id=0f94f28c&scoped=true"
import script from "./ScreenObjectQuickView.vue?vue&type=script&lang=js"
export * from "./ScreenObjectQuickView.vue?vue&type=script&lang=js"
import style0 from "./ScreenObjectQuickView.vue?vue&type=style&index=0&id=0f94f28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94f28c",
  null
  
)

export default component.exports